import React, {useState} from 'react';
import {Button, Form, Spinner} from 'react-bootstrap';
import Alert from '../alert/alert';
import {changeAuthState, cognitoForgotPassword, cognitoSendCode} from '../../helpr/authHelper';
import {AuthState} from '../../helpr/authHelper';
import {AUTH_INVALID_PASSWORD, AUTH_INVALID_USERNAME,
  AUTH_INVALID_CODE, AUTH_SEND_CODE_SUCCESS, AUTH_FORGOT_PASSWORD_SUCCESS} from '../../helpr/constants';
import styles from './custom-forgot-password.module.scss';
import usernameIcon from '../../assets/login-username-icon.svg';
import passwordIcon from '../../assets/login-password-icon.svg';

const CustomForgotPasswordContainer = () => {
  return (
    <div className={styles['custom-container']}>
      <CustomForgotPassword />
    </div>
  );
};

export const CustomForgotPassword = () => {
  const [forgotPasswordState, setForgotPasswordState] = useState({ onForgot: false, onReset: false });
  const [showReset, setShowReset] = useState(false);
  const [showErr, setShowErr] = useState({
    msg: '',
    type: '',
    isVisible: false,
    onClose: () => setShowErr(s => ({ ...s, isVisible: false })),
  });

  const onChange = (e) => {
    setForgotPasswordState(s => ({ ...s, [e.target.id]: e.target.value.trim() }));
  };

  const sendCode = async (e) => {
    e.preventDefault();
    setForgotPasswordState(s => ({ ...s, onForgot: true }));
    try {
      const { fpUsername } = forgotPasswordState;
      if (!fpUsername) throw new Error(AUTH_INVALID_USERNAME);
      const data = await cognitoSendCode(fpUsername);
      if (data) {
        setShowErr(s => ({ ...s, isVisible: true, msg: AUTH_SEND_CODE_SUCCESS, type: 'alert-success-custom' }));
      }
      document.getElementById('send-code').reset();
      setShowReset(true);
    } catch (error) {
      setShowErr(s => ({ ...s, isVisible: true, msg: error.message, type: 'alert-danger-custom' }));
    } finally {
      setForgotPasswordState(s => ({ ...s, onForgot: false }));
    }
  };

  const resetPassword = async (e) => {
    e.preventDefault();
    setForgotPasswordState(s => ({ ...s, onReset: true }));
    try {
      const { fpUsername, fpCode, fpPassword } = forgotPasswordState;
      if (!fpCode) throw new Error(AUTH_INVALID_CODE);
      if (!fpPassword) throw new Error(AUTH_INVALID_PASSWORD);
      await cognitoForgotPassword(fpUsername, fpCode, fpPassword);
      setShowErr(s => ({
        ...s,
        isVisible: true,
        msg: AUTH_FORGOT_PASSWORD_SUCCESS,
        type: 'alert-success-custom',
        onClose: async () => {
          setShowErr(s => ({ ...s, isVisible: false }));
          document.getElementById('reset-password').reset();
          await changeAuthState(AuthState.SignIn);
          setShowReset(false);
          setForgotPasswordState({});
        },
      }));
    } catch (error) {
      setShowErr(s => ({ ...s, isVisible: true, msg: error.message, type: 'alert-danger-custom' }));
    } finally {
      setForgotPasswordState(s => ({ ...s, onReset: false }));
    }
  };

  const handleBackToSignIn = async () => {
    await changeAuthState(AuthState.SignIn);
    setShowReset(false);
    setForgotPasswordState({});
  };

  return (
    <div className={styles['form-card']}>
      <Alert options={showErr} />
      {!showReset ? (
        <>
          <div className={styles['header']}>
            <h3>Forgot your password?</h3>
            <span>A verification code will be sent to your registered email</span>
          </div>
          <div className={styles['form-section']}>
            <Form id="send-code" onSubmit={sendCode}>
              <Form.Group className={styles['input-section']} controlId="fpUsername">
                <i className={styles['icon']}><img src={usernameIcon} alt="" /></i>
                <Form.Control
                  aria-label="fpUsername"
                  type="text"
                  placeholder="Username"
                  className={styles['forgot-pw-input']}
                  onChange={onChange}
                />
              </Form.Group>
              <div className={styles['login-button']}>
                <Button disabled={forgotPasswordState.onForgot} variant="primary" type="submit">
                  {forgotPasswordState.onForgot ? <Spinner size="sm" animation="border" /> : 'SEND CODE'}
                </Button>
              </div>
            </Form>
          </div>
        </>
      ) : (
        <>
          <div className={styles['header']}>
            <h3>Reset your password</h3>
          </div>
          <div className={styles['form-section']}>
            <Form id="reset-password" onSubmit={resetPassword}>
              <Form.Group className={styles['input-section']} controlId="fpCode">
                <i className={styles['icon']}><img src={passwordIcon} alt="" /></i>
                <Form.Control
                  className={styles['forgot-pw-input']}
                  aria-label="fpCode"
                  type="text"
                  placeholder="Verification Code"
                  onChange={onChange}
                />
              </Form.Group>
              <Form.Group className={styles['input-section']} controlId="fpPassword">
                <i className={styles['icon']}><img src={passwordIcon} alt="" /></i>
                <Form.Control
                  className={styles['forgot-pw-input']}
                  type="password"
                  placeholder="Password"
                  onChange={onChange}
                />
              </Form.Group>
              <div className={styles['login-button']}>
                <Button disabled={forgotPasswordState.onReset} variant="primary" type="submit">
                  {forgotPasswordState.onReset ? <Spinner size="sm" animation="border" /> : 'RESET PASSWORD'}
                </Button>
              </div>
            </Form>
          </div>
        </>
      )}
      <div className={styles['login-options']}>
        <a href="#" onClick={handleBackToSignIn}>Back to Sign In</a>
      </div>
    </div>
  );
};

export default CustomForgotPasswordContainer;
